import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  margin-right: 5px;

  img {
    margin-left: -25px;
    margin-bottom: 1px;
    cursor: pointer;
  }
`;

export const Input = styled.input`
  border: none;
  padding: 5px 2px;
  border-bottom: 1px solid black;
  background: none;
`;
